<template>
<div class="importNais">
  <div class="topButton">
    <div class="upload">
      <!--上传按钮-->
      <el-upload :action="action" :on-success="uploadSuc" :on-error="uploadErr" :on-exceed="uploadMore" :on-remove="uploadRem" :file-list="fileList" title="点击上传NAIS数据EXCEL表格" auto-upload show-file-list :limit="1" :with-credentials="true"
        style="display: flex;">
        <el-button type="primary" class="uploadBut">+&nbsp;上传文件</el-button>
      </el-upload>
    </div>

    <div class="search">
      <!--案例查找区-->
      <el-input placeholder="请输入要查找的案例编号" v-model="findNumber" :clearable="true"></el-input>
      <el-button type="info" @click="search">搜索</el-button>
      <el-button type="info" @click="allData">查看总表</el-button>
      <el-button type="info" @click="saveCase" :disabled="repeat">保存选中项</el-button>
    </div>
  </div>

  <div class="data" ref="date">
    <!--表格组件-->
    <el-table ref="naisData" tooltip-effect="dark" border highlight-current-row :data="tableData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table"
      @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
      </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="tableData.length" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</div>
</template>

<script>
import api from '../assets/javascript/api'
import qs from 'qs'

export default {
  name: "导入NAIS数据",
  data() {
    return {
      /*加载动画*/
      loading: false,
      /*多选时标记当前行的标记*/
      idKey: "caseNumber",
      /*要查找的案例编号*/
      findNumber: "",
      /*查找函数的使用次数*/
      start: 1,
      /*文件上传的地址*/
      action: api + '/nais/nais',
      /*通过key刷新表格*/
      table: 1,
      /*防止重复点击*/
      repeat: false,
      /*保存的案例编号*/
      caseNumbers: [],
      /*上传文件的列表*/
      fileList: [],
      /*分页器的参数*/
      pageInfo: {
        currentPage: 1,
        pageSize: 5,
      },
      /*当前页选中项*/
      multipleSelection: [],
      /*所有选中项*/
      multipleSelectionAll: [],
      /*表格的最大高度*/
      tableHeight: '',
      /*表格组件渲染数组*/
      tableTitle: [{
          label: "案例编号",
          width: "120",
          prop: "caseNumber",
          show: false
        },
        {
          label: "参与方总数",
          width: "120",
          prop: "participantsNum",
          show: false
        },
        {
          label: "事故形态",
          width: "",
          prop: "accidentForm",
          show: true
        },
        {
          label: "事故具体类型",
          width: "",
          prop: "accidentType",
          show: true
        },
        {
          label: "障碍物类型",
          width: "",
          prop: "obstacleType",
          show: true
        },
        {
          label: "天网及其他视频",
          width: "120",
          prop: "otherVideo",
          show: false
        },
        {
          label: "事故分类",
          width: "130",
          prop: "classificationOfAccidents",
          show: false
        },
        {
          label: "路段信息",
          width: "120",
          prop: "roadInformation",
          show: false
        },
        {
          label: "天气",
          width: "130",
          prop: "weather",
          show: false
        },
        {
          label: "事故发生时段",
          width: "130",
          prop: "periodOfAccident",
          show: false
        },
      ],
      /*表格数据*/
      tableData: [],
      /*表格数据暂存数组*/
      tableData_copy: [],
      /*查找案例暂存数组*/
      find_copy: []
    }
  },
  methods: {
    /*文件上传成功*/
    uploadSuc(res) {
      if (res.code === "0000") {
        let data = res.data.data;
        /*设置一个数组*/
        let tabledata = [];
        /*遍历到res内的每一个对象*/
        for (let i = 0; i < data.length; i++) {
          let obj = {};
          /*for in 遍历对象内的key*/
          for (let item in data[i]) {
            /*当key为总体信息*/
            if (item === "toatal") {
              let total = data[i].toatal;
              /*for of + object.key 遍历key+value并进行筛选*/
              for (let key of Object.keys(total)) {
                if (key === "caseNumber" || key === "participantsNum" || key === "accidentForm" || key === "accidentType" || key === "obstacleType" || key === "otherVideo" || key === "classificationOfAccidents") {
                  obj[key] = total[key];
                }
              }
            }
            if (item === "environment") {
              let environment = data[i].environment;
              for (let key of Object.keys(environment)) {
                if (key === "roadInformation" || key === "weather" || key === "periodOfAccident") {
                  obj[key] = environment[key];
                }
              }
            }
          }
          tabledata[i] = obj;
        }
        this.tableData = tabledata;
        this.$message({
          message: 'NAIS文件上传成功',
          type: 'success',
          duration: 1500
        });
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1500
        });
      }
    },
    /*文件上传失败*/
    uploadErr(err) {
      this.$message({
        message: err.msg,
        type: 'error',
        duration: 1500
      });
    },
    /*文件个数大于1*/
    uploadMore() {
      this.$message({
        message: '一次仅限上传一个文件',
        type: 'error',
        duration: 1000
      });
    },
    /*移除文件列表*/
    uploadRem() {
      this.fileList = [];
      this.$message({
        message: '删除成功',
        type: 'success',
        duration: 1000
      });
    },
    /*搜索函数*/
    search() {
      if (this.start === 1) {
        this.tableData_copy = this.tableData;
        this.tableData = [];
      }
      if (this.find_copy.length > 0) {
        this.tableData = [];
        this.tableData = this.tableData.concat(this.find_copy);
      }
      this.start++;
      this.loading = true;
      this.$http.get(
          '/nais/nais/' + this.findNumber
        )
        .then((res) => {
          this.findNumber = "";
          let obj = {};
          for (let item in res) {
            if (item === "toatal") {
              let total = res.toatal;
              for (let key of Object.keys(total)) {
                if (key === "caseNumber" || key === "participantsNum" || key === "accidentForm" || key === "accidentType" || key === "obstacleType" || key === "otherVideo" || key === "classificationOfAccidents") {
                  obj[key] = total[key];
                }
              }
            }
            if (item === "environment") {
              let environment = res.environment;
              for (let key of Object.keys(environment)) {
                if (key === "roadInformation" || key === "weather" || key === "periodOfAccident") {
                  obj[key] = environment[key];
                }
              }
            }
          }
          /*防止重复查找*/
          if (this.tableData.length > 0) {
            let time = 1;
            for (let i = 0; i < this.tableData.length; i++) {
              if (obj.caseNumber === this.tableData[i].caseNumber) {
                this.$message({
                  message: '该案例已经被查找',
                  type: 'error',
                  duration: 1000
                });
                time++;
                break;
              }
            }
            if (time !== 2) {
              this.tableData.push(obj);
            }
          } else {
            this.tableData.push(obj);
          }
          this.$nextTick(
            this.loading = false,
          );
        })
        .catch((err) => {
          console.log(err);
          this.$nextTick(
            this.loading = false,
          );
        })
    },
    /*查看总表*/
    allData() {
      this.find_copy = this.tableData;
      this.tableData = this.tableData_copy;
    },
    /*保存已经勾选案例*/
    saveCase() {
      /*禁用按钮防止误触*/
      this.repeat = true;
      let dateNumber = [];
      /*跳转到第一页*/
      this.handleCurrentChange(this.pageInfo.currentPage);
      /*遍历数组取得caseNumber*/
      for (let i = 0; i < this.multipleSelectionAll.length; i++) {
        dateNumber[i] = this.multipleSelectionAll[i].caseNumber;
      }
      this.caseNumbers = dateNumber;
      let formData = new FormData();
      for (let i = 0; i < this.caseNumbers.length; i++) {
        formData.append('caseNumbers', this.caseNumbers[i]);
      }
      this.loading = true;
      this.$http.post(
          '/nais/nais/sn',
          formData, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
        .then((res) => {
          this.$message({
            message: "保存成功",
            type: 'success',
            center: true,
            duration: 1500
          });
          this.repeat = false;
          this.$nextTick(
            this.loading = false,
          )
        })
        .catch((error) => {
          console.log(error);
          this.repeat = false;
          this.$nextTick(
            this.loading = false,
          )
        })
    },
    /* 分页大小切换*/
    handleSizeChange(val) {
      this.changePageCoreRecordData();
      this.pageInfo.pageSize = val;
      this.queryData();
    },
    /*分页切换*/
    handleCurrentChange(val) {
      this.changePageCoreRecordData();
      this.pageInfo.currentPage = val;
      this.queryData();
    },
    /*表格选择*/
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /*分页勾选，再次调用*/
    queryData() {
      setTimeout(() => {
        this.setSelectRow();
      }, 20);
    },
    /*设置选中的方法*/
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let selectAllIds = [];
      let that = this;
      this.multipleSelectionAll.forEach(row => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.naisData.clearSelection();
      for (let i = 0; i < this.tableData.length; i++) {
        if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
          // 设置选中
          this.$refs.naisData.toggleRowSelection(this.tableData[i], true);
        }
      }
    },
    /*记忆选中核心方法*/
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      let selectAllIds = [];
      this.multipleSelectionAll.forEach(row => {
        selectAllIds.push(row[idKey]);
      });
      let selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach(row => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      let noSelectIds = [];
      // 得到当前页没有选中的id
      this.tableData.forEach(row => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach(id => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] === id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    /*获取高度*/
    getHeight() {
      /*定义两个高度，初始高度和现在高度*/
      let nowH;
      /*延迟获取当前高度*/
      this.$nextTick(() => {
        nowH = this.$refs.date.offsetHeight - 36;
      });
      let height = this.tableHeight;
      /*比对操作*/
      if (nowH !== height) {
        this.tableHeight = nowH;
        this.table++;
      }
    }
  },
  mounted() {
    /*当真实DOM渲染完成后调用该钩子获取当前data元素的高度并保存*/
    /*在created调用会报bug因为页面初始化时vue生命周期中先虚拟DOM，此时真实的DOM还没有挂载，无法获取*/
    this.$nextTick(() => {
      this.tableHeight = this.$refs.date.offsetHeight - 36;
    });
  },
  created() {
    /*在页面初始化时调用获取实时高度函数*/
    this.getHeight();
  }
}
</script>

<style scoped>
.importNais {
  width: 100%;
  height: calc(100% - 34px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.topButton {
  background-color: #E9EBEE;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
}

.data {
  width: 100%;
  height: calc(100% - 50px);
}

.el-pagination {
  text-align: center;
}

.upload {
  display: flex;
  align-items: center;
  height: 100%;
  width: 35%;
  padding-left: 2%;
}

.search {
  display: flex;
  align-items: center;
  height: 100%;
  width: 60%;
  padding-right: 2%;
}

.uploadBut {
  background-color: cadetblue;
}
</style>



// WEBPACK FOOTER //
// src/data/importNais.vue